import { render, staticRenderFns } from "./ai-question-list-item.vue?vue&type=template&id=42a60fc5&scoped=true"
import script from "./ai-question-list-item.vue?vue&type=script&lang=js"
export * from "./ai-question-list-item.vue?vue&type=script&lang=js"
import style0 from "./ai-question-list-item.vue?vue&type=style&index=0&id=42a60fc5&prod&lang=scss&scoped=true"
import style1 from "./ai-question-list-item.vue?vue&type=style&index=1&id=42a60fc5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a60fc5",
  null
  
)

export default component.exports